// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"AccordionContent-module--contentContainer--21Lap","content":"AccordionContent-module--content--1082Z","active":"AccordionContent-module--active--q3C1C"};